import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id DA4F5288-0BD2-4D9F-A49D-8E40E9893789
 * name battery-arrow-up
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-arrow-up.svg
 * tags
 * - Battery 
 */
export const BatteryArrowUpIcon = createSvgIcon(<><path d="M13.54 22H7.33C6.6 22 6 21.4 6 20.67V5.33C6 4.6 6.6 4 7.33 4H9V2H15V4H16.67C17.4 4 18 4.6 18 5.33V12C14.69 12 12 14.69 12 18C12 19.54 12.58 20.94 13.54 22M20.94 17.5L17.94 14.5L14.94 17.5H16.94V21.5H18.94V17.5H20.94" /></>, 'BatteryArrowUpIcon');
export default BatteryArrowUpIcon